// extracted by mini-css-extract-plugin
export default {"icon-container":"SocialShare_icon-container__gtea1"};